import React from 'react';
import { Box, Typography} from '@mui/material';

export default function InputStylefield({ children, name, topSpace }) {
  return (
    <Box
      sx={{
        position: 'relative',
        '& textarea': {
          width: '100%',
          bgcolor: '#EDF2F7',
          fontFamily: 'Inter',
        },
      }}
      className="inputStylefield"
    >
      <Typography
       
        component="label"
        sx={{
          fontWeight: 600,
          fontFamily: 'Inter',
          fontSize: 12,
        }}
      >
        {name}
      </Typography>
      {children}
    </Box>
  );
}


